<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <!-- Circular background -->
    <circle cx="40" cy="40" r="40" :fill="bgColor" />
    <!-- Blue ring border -->
    <circle
      cx="40"
      cy="40"
      r="37"
      fill="none"
      :stroke="accentColor"
      stroke-width="2.5"
    />

    <!-- Road forming the P shape — outer edge / shadow -->
    <path
      d="M26 68 L26 36 L26 28 C26 18 33 12 42 12 C51 12 56 18 56 26 C56 34 51 38 42 38 L26 38"
      stroke="#1a2744"
      stroke-width="13"
      stroke-linecap="round"
      stroke-linejoin="round"
      fill="none"
    />

    <!-- Road surface — white -->
    <path
      d="M26 68 L26 36 L26 28 C26 18 33 12 42 12 C51 12 56 18 56 26 C56 34 51 38 42 38 L26 38"
      stroke="white"
      stroke-width="10"
      stroke-linecap="round"
      stroke-linejoin="round"
      fill="none"
    />

    <!-- Center lane dashes — vertical stem -->
    <line
      x1="26"
      y1="65"
      x2="26"
      y2="40"
      stroke="#9ca3af"
      stroke-width="1.5"
      stroke-dasharray="4 3.5"
      stroke-linecap="round"
    />

    <!-- Center lane dashes — curve up and around the P bowl -->
    <path
      d="M26 38 L26 28 C26 19 33 13.5 42 13.5 C50 13.5 54.5 19 54.5 26 C54.5 33 50 36.5 42 36.5"
      stroke="#9ca3af"
      stroke-width="1.5"
      stroke-dasharray="4 3.5"
      stroke-linecap="round"
      fill="none"
    />

    <!-- Paper airplane — launching from top of P -->
    <g transform="translate(52, 6)">
      <!-- Main body - top wing -->
      <polygon points="0,10 20,0 8,7" :fill="accentColor" />
      <!-- Bottom wing (darker) -->
      <polygon points="8,7 20,0 10,16" :fill="accentDark" />
      <!-- Center fold line -->
      <line
        x1="10"
        y1="16"
        x2="13"
        y2="8"
        :stroke="accentColor"
        stroke-width="0.8"
        opacity="0.7"
      />
    </g>
  </svg>
</template>

<script setup>
defineProps({
  size: { type: [Number, String], default: 40 },
  bgColor: { type: String, default: "#0f172a" },
  accentColor: { type: String, default: "#ff6b00" },
  accentDark: { type: String, default: "#e05500" },
});
</script>
